import { CheckOutlined, BarChartOutlined, ApartmentOutlined, PieChartOutlined, /*FundOutlined,*/ TableOutlined, PartitionOutlined, SwapOutlined, TeamOutlined, CalendarOutlined, ThunderboltOutlined, TrophyOutlined } from '@ant-design/icons';
import { RubleIcon } from '../components/common';
import type { StageConfig } from './types';


export type Stage1View = 'planning' | 'cpr' | 'periods';
export type Stage2View = 'planning' | 'periods';
export type Stage4View = 'sales-plan' | 'mp-distribution' | 'kd-mp-verification' | 'motivation-pp';
export type Stage5View = 'sales-plan' | 'knr' | 'dynamic-pp' | 'periods';


export const SALES_STAGES: StageConfig[] = [
  {
    title: '1 этап',
    description: 'План продаж по БГ',
    icon: <RubleIcon />,
    path: 'stage-1',
    rbacResource: 'sales_stage1',
    views: [
      { key: 'planning', label: 'БГ', icon: <TeamOutlined /> },
      { key: 'cpr', label: 'ЦПР', icon: <BarChartOutlined /> },
      { key: 'periods', label: 'Периоды', icon: <CalendarOutlined /> },
    ],
  },
  {
    title: '2 этап',
    description: 'План продаж по ЦПР-ТН',
    icon: <BarChartOutlined />,
    path: 'stage-2',
    rbacResource: 'sales_stage2',
    views: [
      { key: 'planning', label: 'Планирование', icon: <TableOutlined /> },
      { key: 'periods', label: 'Периоды', icon: <CalendarOutlined /> },
    ],
  },
  { title: '3 этап', description: 'План продаж ЦПР-ТН-SKU по БГ', icon: <CheckOutlined />, path: 'stage-3', rbacResource: 'sales_stage3' },
  {
    title: '4 этап',
    description: 'План продаж ЦПР-ТН-SKU МП',
    icon: <ApartmentOutlined />,
    path: 'stage-4',
    rbacResource: 'sales_stage4',
    views: [
      { key: 'sales-plan', label: 'План продаж', icon: <TableOutlined /> },
      { key: 'mp-distribution', label: 'БГ-ЦПР-ТН-МП', icon: <PartitionOutlined /> },
      { key: 'kd-mp-verification', label: 'Сверка КД/МП', icon: <SwapOutlined /> },
      { key: 'motivation-pp', label: 'Мотивационный ПП', icon: <TrophyOutlined /> },
    ],
  },
  {
    title: '5 этап',
    description: 'План продажи по МП',
    icon: <PieChartOutlined />,
    path: 'stage-5',
    rbacResource: 'sales_stage5',
    views: [
      { key: 'sales-plan', label: 'План продаж', icon: <TableOutlined /> },
      { key: 'periods', label: 'Периоды', icon: <CalendarOutlined /> },
      { key: 'knr', label: 'КНР', icon: <RubleIcon /> },
      { key: 'dynamic-pp', label: 'Динамический ПП', icon: <ThunderboltOutlined /> },
    ],
  },
  // { title: '6 этап', description: '-', icon: <FundOutlined />, path: 'stage-6' },
];
